import { render } from "./TreeItem.vue?vue&type=template&id=1706ad57"
import script from "./TreeItem.js?vue&type=script&lang=js"
export * from "./TreeItem.js?vue&type=script&lang=js"

import "./TreeItem.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__